import * as Yup from 'yup';
import { IModel } from '~/lib/model';

export interface IDeal extends IModel {
    name: string;
    isActive: boolean;
    supplyPackageId: number;
    supplyPackageName: string;
    agencyId: number;
    agencyName: string;
    bidfloor: number;
    bidfloorCur: string;
    privateAuction: boolean;
    bidderIds: number[];
}

export const DealSchema = Yup.object().shape<IDeal>({
    id: Yup.string().nullable().required().max(100),
    name: Yup.string().required().nullable(false).max(100),
    isActive: Yup.boolean().required(),
    supplyPackageId: Yup.number().required().min(1, 'must be selected'),
    supplyPackageName: Yup.string(),
    agencyId: Yup.number().required().min(1, 'must be selected'),
    agencyName: Yup.string(),
    bidfloor: Yup.number().required(),
    bidfloorCur: Yup.string().required().min(3).max(3),
    privateAuction: Yup.boolean().required(),
    bidderIds: Yup.array<number>(),
});

export const defaultDeal: IDeal = {
    id: null,
    name: '',
    isActive: false,
    supplyPackageId: 0,
    supplyPackageName: '',
    agencyId: 0,
    agencyName: '',
    bidfloor: 0,
    bidfloorCur: 'USD',
    privateAuction: false,
    bidderIds: [],
};
